import * as Yup from "yup";
import { addYears } from "date-fns";

import { Salutation } from "@hubcapp/types";

import { lessonTypes } from "./types";

const newLearnerValidationSchema = Yup.object().shape({
  salutation: Yup.mixed()
    .oneOf(Object.values(Salutation))
    .required("Please select an option"),
  firstName: Yup.string()
    .min(2, "Please enter a valid name")
    .matches(/^[a-zA-Z'-]*$/, "Please enter a valid name")
    .required("Please enter a name "),
  lastName: Yup.string()
    .min(2, "Please enter a surname")
    .matches(/^[a-zA-Z'-]*$/, "Please enter a valid name")
    .required("Please enter a surname"),
  pickupPostcode: Yup.string()
    .matches(/^(?!\s*$).+/, "Please enter a postcode")
    .matches(
      /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/,
      "Please check this postcode is valid",
    )
    .required("Please enter a postcode"),
  address: Yup.string().required("Please select an address"),
  mobileNumber: Yup.string().matches(
    /^$|^(07\d{8,12}|447\d{7,11})$/,
    "Please enter a valid mobile number",
  ),
  emailAddress: Yup.string().email("Please enter a valid email address"),
  dateOfBirth: Yup.date()
    .max(
      // TODO: Discus minimum age for new learners
      addYears(new Date(Date.now()), -12),
      "Please enter a valid date of birth",
    )
    .typeError("Please enter a valid date of birth")
    .required("Please enter a valid date of birth"),
  lessonType: Yup.mixed()
    .oneOf(lessonTypes)
    .required("Please select an option"),
  lessonPrice: Yup.number()
    .typeError("Check hourly rate is a valid amount")
    .moreThan(-1, "Check hourly rate is not negative")
    .required("Check hourly rate is a valid amount")
    .test(
      "Is25pIncrement",
      "Hourly rate needs to be in £0.25 increments",
      val => !!val && val % 0.25 === 0,
    ),
  franchiseId: Yup.string().required(
    "Please select which franchise this learner will learn with",
  ),
});

export default newLearnerValidationSchema;
